import React, { useEffect, useState } from 'react'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'

function CustomAutocomplete(props) {
    const [selectedOption, setSelectedOption] = useState([])
    const [singleOption, setSingleOption] = useState(null)

    useEffect(() => {
        setSelectedOption([])
    }, [props.onClear])

    const getMultipleValues = (values) => {
        setSelectedOption(values)
        return values.map((item) => item.value)
    }

    const getSingleValue = (value) => {
        setSingleOption(value)
        return value?.value
    }

    const getReturnMultipleValues = (value) => {
        const returnValue = props.options.filter(
            (item) => item.value === parseInt(value)
        )

        if (returnValue.length) {
            const allValues = selectedOption.concat(returnValue)
            setSelectedOption(allValues)
            props.onChange(getMultipleValues(allValues))
        }
    }

    const getReturnSingleValues = (value) => {
        const returnValue = props.isString
            ? props.options.filter((item) => item.value == value)
            : props.options.filter((item) => item.value == parseInt(value))

        if (returnValue.length) {
            const newValue = returnValue[0]
            setSingleOption(newValue)
            props.onChange(getSingleValue(newValue))
        }
    }

    useEffect(() => {
        if (props.options && props.options.length) {
            if (
                props.value !== null &&
                props.value !== undefined &&
                props.value !== ''
            ) {
                if (props.multiple) {
                    const filtered = props.options.filter((item) =>
                        props.value.includes(item.value)
                    )
                    setSelectedOption(filtered)
                } else {
                    const filtered = props.options.find(
                        (item) => item.value == props.value
                    )
                    setSingleOption(filtered || null)
                }
            } else {
                setSingleOption(null)
                setSelectedOption([])
            }
        } else {
            setSingleOption(null)
            setSelectedOption([])
        }
    }, [props.value, props.options])

    const customFilter = (options, { inputValue }) => {
        const inputLowerCase = inputValue.toLowerCase()

        return options.filter((option) => {
            const label = option?.show?.toLowerCase?.() || ''
            return props?.searchType === 'startsWith'
                ? label.startsWith(inputLowerCase)
                : label.includes(inputLowerCase)
        })
    }

    const getOptionLabelSafe = (option) => {
        if (!option || typeof option !== 'object') return ''
        return option.show || ''
    }

    const isOptionEqual = (option, value) => {
        return option?.value === value?.value
    }

    return (
        <>
            {props.multiple ? (
                <Autocomplete
                    id={props.id}
                    multiple
                    filterOptions={customFilter}
                    options={props.options}
                    value={selectedOption}
                    freeSolo={props.freeSolo}
                    onChange={(event, value) => {
                        if (value) {
                            props.onChange(getMultipleValues(value))
                        } else {
                            props.onChange([])
                        }
                    }}
                    isOptionEqualToValue={isOptionEqual}
                    getOptionLabel={getOptionLabelSafe}
                    renderOption={(optionProps, option) => (
                        <li {...optionProps} key={option.value}>
                            {option.show}
                        </li>
                    )}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={props.label}
                            variant={props.variant || 'outlined'}
                            error={props.error}
                            size={props.size}
                            name={props.name}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && e.target.value) {
                                    getReturnMultipleValues(e.target.value)
                                }
                            }}
                            helperText={props.helperText}
                            autoFocus={props.autoFocus}
                            disabled={props.disabled}
                        />
                    )}
                />
            ) : (
                <Autocomplete
                    id={props.id}
                    filterOptions={customFilter}
                    options={props.options}
                    value={singleOption}
                    freeSolo={props.freeSolo}
                    onChange={(event, value) => {
                        if (value) {
                            props.onChange(getSingleValue(value))
                        } else {
                            props.onChange('')
                        }
                    }}
                    isOptionEqualToValue={isOptionEqual}
                    getOptionLabel={getOptionLabelSafe}
                    renderOption={(optionProps, option) => (
                        <li {...optionProps} key={option.value}>
                            {option.show}
                        </li>
                    )}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={props.label}
                            variant={props.variant || 'outlined'}
                            error={props.error}
                            size={props.size}
                            name={props.name}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && e.target.value) {
                                    getReturnSingleValues(e.target.value)
                                }
                            }}
                            onPaste={(e) => {
                                if (props.triggerPasteEvent) {
                                    getReturnSingleValues(e.target.value)
                                }
                            }}
                            helperText={props.helperText}
                            autoFocus={props.autoFocus}
                            disabled={props.disabled}
                        />
                    )}
                />
            )}
        </>
    )
}

export default CustomAutocomplete
